import { useRef, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/jointAssetsLiabilities";
import toast from "react-hot-toast";
import MainTitle from "app/components/common/typography/MainTitle";
import SubTitle from "app/components/common/typography/SubTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import InfoTitle from "app/components/common/typography/InfoTitle";
import Checkbox from "app/components/common/inputs/Checkbox";
import Loader from "app/components/common/Loader";
import { useNavigate } from "react-router-dom";
import UploadNewBankStatement from "app/components/imagesUploads/joint/UploadNewBankStatement";
import ConnectBankBox from "app/components/imagesUploads/joint/ConnectBank";
import UploadIcon from "app/assets/icons/UploadIcon";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";
import { getPresignedUrlsPromise } from "app/utils/getPresignedUrlsPromise";
import httpRequest from "app/lib/axios/index";
interface FormData {
  bankStatement: File[] | null;
  bankStatementTerms: boolean;
  cobankStatementTerms: boolean;
  cobankStatement: File[] | null;
}

const PartSeven: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPending, setisPending] = useState<boolean>(false);

  const {
    bankStatement,
    cobankStatement,
    bankStatementTerms: bankStatementTermsValue,
    cobankStatementTerms: cobankStatementTermsValue,
    ...others
  } = useSelector((state: RootState) => state.jointAssetsLiabilities.stepsData);

  const savedIds = useSelector(
    (state: RootState) => state.loanTypesSteps?.savedIds
  );

  const frontFileInputRef = useRef<HTMLInputElement>(null);
  const cofrontFileInputRef = useRef<HTMLInputElement>(null);
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    clearErrors,
    setError,
  } = useForm<FormData>({
    defaultValues: {
      bankStatementTerms: false,
      cobankStatementTerms: false,
    },
  });
  const statement = watch("bankStatement");
  const costatement = watch("cobankStatement");
  const cobankStatementTerms = watch("cobankStatementTerms");
  const bankStatementTerms = watch("bankStatementTerms");

  // Handle file selection

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    // Clear previous errors
    clearErrors("bankStatement");

    if (!files || files.length === 0) {
      e.target.value = "";
      setValue("bankStatement", null); // Clear files in form state
      return;
    }

    const newFilesArray = Array.from(files);
    const existingFiles = (watch("bankStatement") || []) as File[];

    // Filter out duplicates
    const filteredNewFiles = newFilesArray.filter(
      (newFile) =>
        !existingFiles.some(
          (existingFile) =>
            existingFile.name === newFile.name &&
            existingFile.size === newFile.size
        )
    );

    const totalFiles = existingFiles.length + filteredNewFiles.length;

    // Validation: max number of files
    if (totalFiles > 10) {
      setError("bankStatement", {
        type: "maxFiles",
        message: "You can upload up to 10 files only",
      });
      e.target.value = "";
      return;
    }

    // Validation: size and type
    const invalidFiles = filteredNewFiles.filter(
      (file) =>
        file.size > 5 * 1024 * 1024 ||
        !["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    );

    if (invalidFiles.length > 0) {
      const errorMessages = invalidFiles.map((file) => {
        if (file.size > 5 * 1024 * 1024) return `${file.name} exceeds 5MB`;
        return `${file.name} has an invalid type`;
      });

      setError("bankStatement", {
        type: "validation",
        message: errorMessages.join("\n"),
      });

      e.target.value = "";
      return;
    }

    // All validations passed, update the files
    const updatedFiles = [...existingFiles, ...filteredNewFiles];

    setValue("bankStatement", updatedFiles);
    clearErrors("bankStatement");

    if (frontFileInputRef.current) frontFileInputRef.current.value = "";
  };

  const cohandleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    // Clear previous errors
    clearErrors("cobankStatement");

    if (!files || files.length === 0) {
      e.target.value = "";
      setValue("cobankStatement", null); // Clear files in form state
      return;
    }

    const newFilesArray = Array.from(files);
    const existingFiles = (watch("cobankStatement") || []) as File[];

    // Remove duplicates (based on name and size)
    const filteredNewFiles = newFilesArray.filter(
      (newFile) =>
        !existingFiles.some(
          (existingFile) =>
            existingFile.name === newFile.name &&
            existingFile.size === newFile.size
        )
    );

    const totalFiles = existingFiles.length + filteredNewFiles.length;

    // Validation: max number of files
    if (totalFiles > 10) {
      setError("cobankStatement", {
        type: "maxFiles",
        message: "You can upload up to 10 files only",
      });
      e.target.value = "";
      return;
    }

    // Validation: size and type
    const invalidFiles = filteredNewFiles.filter(
      (file) =>
        file.size > 5 * 1024 * 1024 ||
        !["image/jpeg", "image/png", "application/pdf"].includes(file.type)
    );

    if (invalidFiles.length > 0) {
      const errorMessages = invalidFiles.map((file) => {
        if (file.size > 5 * 1024 * 1024) return `${file.name} exceeds 5MB`;
        return `${file.name} has an invalid type`;
      });

      setError("cobankStatement", {
        type: "validation",
        message: errorMessages.join("\n"),
      });

      e.target.value = "";
      return;
    }

    // All validations passed
    const updatedFiles = [...existingFiles, ...filteredNewFiles];

    setValue("cobankStatement", updatedFiles);
    clearErrors("cobankStatement");

    if (cofrontFileInputRef.current) cofrontFileInputRef.current.value = "";
  };

  const handleYourConnectinstantly = () => {
    // setisYourModalOpen(!isYourModalOpen);
    if (savedIds?.bankDocLink) {
      window.open(savedIds?.bankDocLink, "_blank", "noopener,noreferrer");
    }
  };
  const handleCoConnectinstantly = () => {
    if (savedIds?.secondBankDocLink) {
      window.open(savedIds?.secondBankDocLink, "_blank", "noopener,noreferrer");
    }
  };

  useEffect(() => {
    if (bankStatementTermsValue != null) {
      setValue("bankStatementTerms", bankStatementTermsValue);
    }
    if (cobankStatementTermsValue != null) {
      setValue("cobankStatementTerms", cobankStatementTermsValue);
    }
  }, [setValue, bankStatementTermsValue, cobankStatementTermsValue]);

  const yourHandleDeleteImage = (indexToDelete: number) => {
    const currentFiles = watch("bankStatement") as File[] | null;

    if (!statement && bankStatement && bankStatement?.length >= 0) {
      const updatedFiles = bankStatement.filter(
        (_, index) => index !== indexToDelete
      );
      dispatch(
        addStepsData({
          ...others,
          bankStatement: updatedFiles || [],
        })
      );
    } else {
      if (!currentFiles) return;
      const updatedFiles = currentFiles.filter(
        (_, index) => index !== indexToDelete
      );
      setValue("bankStatement", updatedFiles.length > 0 ? updatedFiles : null);
    }
  };
  const coHandleDeleteImage = (indexToDelete: number) => {
    const currentFiles = watch("cobankStatement") as File[] | null;

    if (!costatement && cobankStatement && cobankStatement?.length >= 0) {
      const updatedFiles = cobankStatement.filter(
        (_, index) => index !== indexToDelete
      );
      dispatch(
        addStepsData({
          ...others,
          cobankStatement: updatedFiles || [],
        })
      );
    } else {
      if (!currentFiles) return;
      const updatedFiles = currentFiles.filter(
        (_, index) => index !== indexToDelete
      );
      setValue(
        "cobankStatement",
        updatedFiles.length > 0 ? updatedFiles : null
      );
    }
  };

  const onSubmit = async (data: FormData) => {
    const {
      bankStatement,
      cobankStatement,
      bankStatementTerms,
      cobankStatementTerms,
    } = data || {};
    setisPending(true);
    try {
      const hasBankFile =
        Array.isArray(bankStatement) &&
        bankStatement.length > 0 &&
        bankStatement.every((file) => file instanceof File);
      const hasCoBankFile =
        Array.isArray(cobankStatement) &&
        cobankStatement.length > 0 &&
        cobankStatement.every((file) => file instanceof File);

      if (!hasBankFile && !hasCoBankFile) {
        dispatch(
          addStepsData({
            ...others,
            bankStatementTerms,
            cobankStatementTerms,
          })
        );
        navigate(`/joint-signatures`);

        return;
      }

      const uploadedData: any = {
        ...others,
        bankStatementTerms,
        cobankStatementTerms,
      };

      if (bankStatementTerms) {
        uploadedData.bankStatementTerms = bankStatementTerms;
      }
      if (cobankStatementTerms) {
        uploadedData.cobankStatementTerms = cobankStatementTerms;
      }

      let yourPresignedData: any = null;
      let coPresignedData: any = null;
      const presignedRequests: Promise<any>[] = [];

      if (bankStatement && bankStatement.length > 0) {
        const documentTypes = bankStatement.map((_, i) => "bank_statement");
        presignedRequests.push(
          getPresignedUrlsPromise({
            url: `/document/${savedIds.applicantID}/presigned-urls`,
            data: { documentTypes },
          }).then((res) => {
            yourPresignedData = res;
          })
        );
      }

      if (cobankStatement && cobankStatement.length > 0) {
        const documentTypes = cobankStatement.map((_, i) => "bank_statement");
        presignedRequests.push(
          getPresignedUrlsPromise({
            url: `/document/${savedIds.secondApplicantID}/presigned-urls`,
            data: { documentTypes },
          }).then((res) => {
            coPresignedData = res;
          })
        );
      }

      await Promise.all(presignedRequests);

      const allUploads: Promise<any>[] = [];
      const allMetadata: Record<string, any> = {};

      const uploadFilesToS3 = (
        files: File[],
        presignedData: Record<string, { url: string; key: string }>,
        keyPrefix: "bank" | "co"
      ) => {
        const metadata: Record<string, any> = {};
        files.forEach((file, index) => {
          const type =
            index === 0 ? "bank_statement" : `bank_statement_${index}`;
          const presigned = presignedData[type];

          if (presigned?.url && presigned?.key) {
            const uploadPromise = fetch(presigned.url, {
              method: "PUT",
              headers: {
                "Content-Type": file.type,
              },
              body: file,
            });

            allUploads.push(uploadPromise);

            metadata[type] = {
              key: presigned.key,
              fileName: file.name,
              mimeType: file.type,
            };
          }
        });
        allMetadata[keyPrefix] = metadata;
      };

      if (hasBankFile && yourPresignedData) {
        uploadFilesToS3(bankStatement, yourPresignedData, "bank");
      }

      if (hasCoBankFile && coPresignedData) {
        uploadFilesToS3(cobankStatement, coPresignedData, "co");
      }

      await Promise.all(allUploads);

      const uploadMetadataRequests: Promise<any>[] = [];
      if (allMetadata.bank && Object.keys(allMetadata.bank).length > 0) {
        const bankStatements = Object.values(allMetadata.bank);
        uploadMetadataRequests.push(
          Promise.resolve(
            httpRequest
              .post(`/document/${savedIds.applicantID}/bank-statement`, {
                bankStatements,
              })
              .then((res: any) => {

                const urls = res?.data?.documents?.map((doc: any) => doc.url);

                uploadedData.bankStatement = urls;
              })
          )
        );
      }

      if (allMetadata.co && Object.keys(allMetadata.co).length > 0) {
        const cobankStatements = Object.values(allMetadata.co);

        uploadMetadataRequests.push(
          Promise.resolve(
            httpRequest
              .post(`/document/${savedIds.secondApplicantID}/bank-statement`, {
                bankStatements: cobankStatements,
              })
              .then((res: any) => {
                const urls = res?.data?.documents?.map((doc: any) => doc.url);
                uploadedData.cobankStatement = urls;
              })
          )
        );

        uploadedData.cobankStatement = cobankStatements.map(
          (item: any) => item.key
        );
      }
      await Promise.all(uploadMetadataRequests);
      dispatch(addStepsData(uploadedData));
      navigate(`/joint-signatures`);
    } catch (error: any) {
      toast.error(error?.response?.data?.message || "Something went wrong.");
    } finally {
      setisPending(false);
    }
  };

  return (
    <>
      {isPending && (
        <Loader text="Please wait while your documents are being uploaded..." />
      )}
      <ProgressBar progress={100} MB={4} />
      <div className="w-full sm:w-[60%] lg:w-[50%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Securely Verify Your Finances " />
        <SubTitle title="To help us assess your loan eligibility, please choose one of the following secure options to share your financial information" />
      </div>
      <div className="mx-auto w-internalWidth">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex mb-8 flex-col md:flex-col xl:flex-row gap-3 sm:gap-4 justify-between">
            <div className="w-full md:w-full lg:w-w-full xl:w-[49%]">
              <InfoTitle title="Your Details" />
              <div className="text-left">
                <div className="flex gap-4 flex-col xl:flex-row justify-between items-center">
                  <div className="w-full xl:w-[50%]">
                    <ConnectBankBox onClick={handleYourConnectinstantly} />
                  </div>

                  <div className="w-full xl:w-[50%] relative">
                    <UploadNewBankStatement
                      label="Upload bank statements"
                      description="Accepted formats: JPG, PNG, PDF"
                      name="bankStatement"
                      register={register}
                      onChange={handleFileChange}
                      inputRef={frontFileInputRef}
                      disabled={false}
                      icon={<UploadIcon />}
                      required={
                        !(
                          bankStatementTerms || (bankStatement?.length || 0) > 0
                        )
                      }
                      uploadedFiles={statement || bankStatement}
                      handleDeleteImage={yourHandleDeleteImage}
                      hasSavedFiles={
                        !!statement?.length || !!bankStatement?.length
                      }
                    />
                    {errors.bankStatement && (
                      <ErrorsMessage
                        title={errors.bankStatement.message}
                        className="absolute top-[100%] left-0"
                      />
                    )}
                  </div>
                </div>
                <div className="mt-6">
                  <h6 className="font-Mulish text-base font-semibold text-[#313131]">
                    Why We Ask for This
                  </h6>
                  <p className="text-[#585C7B] font-Mulish text-base font-normal">
                    We use your financial information to responsibly assess your
                    ability to meet loan repayments. Verifying your income and
                    expenses helps us make faster, fairer lending decisions —
                    all while keeping your data secure and confidential.
                  </p>
                </div>
                <div className="mt-6">
                  <Controller
                    name="bankStatementTerms"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <>
                        <div className="mb-3  sm:mb-1 text-left">
                          <Checkbox
                            id="terms"
                            labelClassName="sm:mt-[-15px]"
                            labelHtml={
                              <>
                                <span className="text-[#313131] text-[12px]">
                                  I have connected bank account
                                </span>
                              </>
                            }
                            checked={value}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              onChange(isChecked);
                              if (isChecked) {
                                clearErrors("bankStatement");
                              }
                            }}
                          />
                        </div>
                      </>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="w-full md:w-full lg:w-w-full xl:w-[49%]">
              <InfoTitle
                title="Co-borrower"
                mobileMarginBottom="sm:mb-4 mb-6"
              />
              <div className="text-left">
                <div className="flex gap-4 flex-col xl:flex-row justify-between items-center">
                  <div className="w-full xl:w-[50%]">
                    <ConnectBankBox onClick={handleCoConnectinstantly} />
                  </div>

                  <div className="w-full xl:w-[50%] relative">
                    <UploadNewBankStatement
                      label="Upload bank statements"
                      description="Accepted formats: JPG, PNG, PDF"
                      name="cobankStatement"
                      register={register}
                      onChange={cohandleFileChange}
                      inputRef={cofrontFileInputRef}
                      disabled={false}
                      icon={<UploadIcon />}
                      required={
                        !(
                          cobankStatementTerms ||
                          (cobankStatement?.length || 0) > 0
                        )
                      }
                      uploadedFiles={costatement || cobankStatement}
                      handleDeleteImage={coHandleDeleteImage}
                      hasSavedFiles={
                        !!costatement?.length || !!cobankStatement?.length
                      }
                    />
                    {errors.cobankStatement && (
                      <ErrorsMessage
                        title={errors.cobankStatement.message}
                        className="absolute top-[100%] left-0"
                      />
                    )}
                  </div>
                </div>
                <div className="mt-6">
                  <h6 className="font-Mulish text-base font-semibold text-[#313131]">
                    Why We Ask for This
                  </h6>
                  <p className="text-[#585C7B] font-Mulish text-base font-normal">
                    We use your financial information to responsibly assess your
                    ability to meet loan repayments. Verifying your income and
                    expenses helps us make faster, fairer lending decisions —
                    all while keeping your data secure and confidential.
                  </p>
                </div>
                <div className="mt-6">
                  <Controller
                    name="cobankStatementTerms"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <>
                        <div className="mb-3  sm:mb-1 text-left">
                          <Checkbox
                            id="coterms"
                            labelClassName="sm:mt-[-15px]"
                            labelHtml={
                              <>
                                <span className="text-[#313131] text-[12px]">
                                  I have connected bank account
                                </span>
                              </>
                            }
                            checked={value}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              onChange(isChecked);
                              if (isChecked) {
                                clearErrors("cobankStatement");
                              }
                            }}
                          />
                        </div>
                      </>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-between mb-6">
            <PreviousButtom
              onClick={() => {
                dispatch(prevStep());
              }}
            >
              Previous
            </PreviousButtom>
            <ContinueButton type="submit" loading={isPending}>
              Next
            </ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PartSeven;
